import { takeLatest } from 'redux-saga/effects'

import { INFO, UPDATE_USER_INFO } from '../types'

import { updateUserInfoWorker, userInfoWorker } from './worker'

export function* watchUser() {
  yield takeLatest(INFO, userInfoWorker)
  yield takeLatest(UPDATE_USER_INFO, updateUserInfoWorker)
}
